import { LABEL_URL } from "../../services/common-urls";
import { JSON_STRING, MHTTPCL } from "../../services/http/http-client";

export const ArtworkService = {
  fetchRelatedFiles: ({
    section = 'releases',
    externalKey = 'release_id',
    externalId = 0,
    artwork = 'artwork2',
  }) => MHTTPCL.get(LABEL_URL, {
    section,
    action: 'artwork_related_files_add_form',
    artwork,
    [externalKey]: externalId,
    output: JSON_STRING,
  }),
}

// section: artists
// action: artwork_related_files_add_form
// label_artist_id: 1608
// artwork: artwork1